import generateNanoId from 'nanoid/generate';

export default () => {
  const alphabet = '0123456789abcdefghijklmnopqrstuvwxyz';

  return generateNanoId(alphabet, 20);
};
